export const asyncForEach = async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
    return Promise.resolve();
};
//# sourceMappingURL=helper.js.map